module.exports = __webpack_public_path__ + "img/蓝莓标题.916632c9.png";